import { IEditTagSearchResultDeviceDTO } from "../../../services/setpoint-administration-service/Models";
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import { UsageSummaryListItem } from "./UsageSummaryListItem";

export type UsageSummaryListProps = {
    title: string,
    name: string,
    items: IEditTagSearchResultDeviceDTO[],
};

export function UsageSummaryList({
    items,
    name,
    title,
}: UsageSummaryListProps) {
    
    return (
        <List
            dense
            component='nav'
            aria-labelledby={`${name}-usage-list-subheader`}
            subheader={
                <ListSubheader id={`${name}-usage-list-subheader`} 
                    component='div' 
                    sx={{fontSize: '1.1rem'}} >

                    {title}
                </ListSubheader>
            }
            
            sx={{
                maxHeight: '500px',
                overflowY: 'auto'
            }}
>
                {items.map(o => 
                    <UsageSummaryListItem key={`${o.id}:${o.objectTypeID}`} item={o} />
                )}
        </List>
      );
}
